import { stateName } from './constants';
import { getSystemConfiguration } from '../system-configuration/selectors';

const localState = state => state[stateName];

export const getPortal = state => {
  var _getSystemConfigurati;

  return ((_getSystemConfigurati = getSystemConfiguration(state)) === null || _getSystemConfigurati === void 0 ? void 0 : _getSystemConfigurati.portal) || localState(state).portal;
};
/**
 * @deprecated - use `/api/v2/configurations/session_defaults` instead or pass it directly as prop
 */

export const DEPRECATED_getCurrency = state => localState(state).currency;
export const getFlavour = state => {
  var _getSystemConfigurati2;

  return ((_getSystemConfigurati2 = getSystemConfiguration(state)) === null || _getSystemConfigurati2 === void 0 ? void 0 : _getSystemConfigurati2.portalFlavour) || localState(state).flavour;
};